export default "__VITE_ASSET__nfoasopc__";